"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasWebAssembly() {
    return !!window.WebAssembly;
}
exports.hasWebAssembly = hasWebAssembly;
